import { BCMSRecord, useBCMSContext, useModel } from "@bcm-dev/bcms-vite";
import ExternalIframe from 'components/shared/containers/ExternalIframe';
import PageContainer from 'components/shared/containers/PageContainer';
import { CenterContentContainer } from 'components/shared/containers/PageLayoutContainer';
import ContentHeaderView from 'components/shared/views/ContentHeaderView';
import ContentSubheaderView from 'components/shared/views/ContentSubheaderView';
import PageContentView from 'components/shared/views/PageContentView';
import ProfilePicker from 'components/shared/widgets/ProfilePicker';
import Classes, { Profile } from "model";
import "./styles.css";
import "./mobile.css";


export default function CHW23Page(props) {
    const options = useModel().branding.options;
    window.BRANDING = { "cards_abi22": options.cards_abi22 };
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const profiles = Profile.initAll(); 
    const subheaderText = options.cards_subheader_abi22;
    const hasSubheaderText = subheaderText ? true : false;

    return (
        <PageContainer className="cardhub-web-page integrated-product-page" ignoreTrigger={ true }>
            <PageContentView>
                { options.multiprofile_abi22 === "true" &&
                    <ProfilePicker profiles = {profiles} ui={{}} onChange = {()=>{}} onSelectClick={()=>{}} disableBusiness="true"/>
                }
                <CenterContentContainer>
                    <ContentHeaderView text="Cards" />
                    { hasSubheaderText && <ContentSubheaderView text={ subheaderText } /> }
                    <ExternalIframe demo="CHW23" key ="CHW23Page"/>
                </CenterContentContainer>
            </PageContentView>
        </PageContainer>
    );
}